module.exports = {
  "rides_ride_audience": "Ride audience",
  "cards_entries_list_button": "Show all",
  "roompicker_add_room": "Legg til rom",
  "roompicker_room": "Rom",
  "guestpicker_ageselection_description": "when you are on holiday",
  "searchwidget_departure": "Avreise",
  "guestpicker_age": "age",
  "supplier_lodging": "lodging",
  "roompicker_rooms": "Rooms",
  "rides_min_height": "Minimum height",
  "rides_age_req": "Age requirements",
  "rides_thrill_level": "Thrill level",
  "rides_icon_details": "Click for icon description or click for more details.",
  "searchwidget_arrival": "Ankomst",
  "supplier_restaurant": "restaurant",
  "rides_max_height": "Maximum height",
  "rides_tickets": "Tickets per guest",
  "supplier_skistation": "skistation",
  "rides_accesibility_title": "Accessibility Information",
  "keywords": "Meta Keywords",
  "searchwidget_booknow": "Bestill nå",
  "guestpicker_ageselection_title": "Age of guests"
}